module.exports = __webpack_public_path__ + "img/Lieutenant.0745cc2a.png";